import { render, staticRenderFns } from "./AccountSettingPass.vue?vue&type=template&id=05decdfa&"
import script from "./AccountSettingPass.vue?vue&type=script&lang=js&"
export * from "./AccountSettingPass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports